export class Phase {
    id: string = '';
    name: string = "";
}